import { User } from 'models';

export class CheckInHeroBookingFee {
	currencyId: number;
	bookingFee: number;
}

export class StayDisruptBookingFee {
	currencyId: number;
	bookingFee: number;
}

export class ApimProductUser {
	userAccountType: string;
	companyName: string;
	emailAddress: string;
	currency: string;
	dealId: string;
}

export class EDepositApiUser extends ApimProductUser {
	nightlyFee: number;
	cancellationFee: number;
	protectionUpperLevel: number;
	protectionLowerLevel: number;
}

export class ApimUser {
	userId: string;
	email: string;
	companyName: string;
	currency: string;
	currencyId: number;

	dealId: string;

	constructor(user?: User) {
		if (user) {
			this.userId = user.id;
			this.email = user.email;
			this.companyName = user.companyName;
			this.currency = user.accountCurrencyName;
			this.currencyId = user.accountCurrencyId;
		}
	}
}

export class CancellationApimUser extends ApimUser {
	accountTypeId: number;
	accountType: string;
	partnerCommission: number;
}

export class CheckInHeroApimUser extends ApimUser {
	accountTypeId: number;
	accountType: string;
	bookingFee: number;
	clientMarkup: string;
}

export class PricingTier {
	type: string; // 'Per Night' | 'Per Booking'
	startAmount: number;
	endAmount: number;
	approved: number = 0;
	flagged: number = 0;
	rejected: number = 0;
	cancelled: number = 0;
	nightThreshold: number = 0;
	additionalRate: number = 0;
}

export class ScreenAndProtectApimUser extends ApimUser {
	accountTypeId: number;
	accountType: string;
	clientMarkup: string;
	invoicingEmailAddress: string;
	techEmailAddress: string;
	flaggedNotProtected: boolean;
	monthlyGeneralDiscount?: number;
	monthlyGeneralDiscountStartDate?: string;
	monthlyGeneralDiscountEndDate?: string;
	monthlyVolumeDiscount?: number;
	thresholdApprovedBookingVolume?: number;
	monthlyVolumeDiscountStartDate?: string;
	monthlyVolumeDiscountEndDate?: string;
	priceIncrease?: number;
	priceIncreaseStartDate?: string;
	pricingTiers: PricingTier[] = [];
}

export class StayDisruptApimUser extends ApimUser {
	accountTypeId: number;
	accountType: string;
	bookingFee: number;
	clientMarkup: string;
}

export type ApimProductType = 'screening' | 'resolution' | 'cancellation' | 'checkInHero' | 'screenAndProtect' | 'stayDisrupt';

export enum ApimUserType {
	CancellationApi = 1,
	CheckInHeroApi = 2,
	ScreeningApi = 3,
	ResolutionApi = 4,
	ScreenAndProtectApi = 5,
	StayDisruptApi = 6,
}

export class ApimProduct {
	displayName: string;
	productName: string;
	subscriptionName: string;
	environment: string;
	userType: ApimUserType;
}

export enum SubscriptionState {
	active = 0, // send subscription update (deactivate)
	suspended = 1,
	submitted = 2,
	rejected = 3,
	cancelled = 4, // send subscription update (reactivate)
	unsubscribed = 5, // send subscription create
}

export class ApimSubscription {
	apimProduct: ApimProduct;
	state: SubscriptionState;
	sid: string;
}

export class ApimUserSubscription {
	developmentSubscriptions: ApimSubscription[];
	sandboxSubscriptions: ApimSubscription[];
	productionSubscriptions: ApimSubscription[];
}

export class ApimProductionSubscription {
	userId: string;
	subscriptionName: string;
	productName: string;
	firstName: string;
	email: string;

	constructor(userId: string, subscriptionName: string, productName: string, firstName: string, email: string) {
		this.userId = userId;
		this.subscriptionName = subscriptionName;
		this.productName = productName;
		this.firstName = firstName;
		this.email = email;
	}
}

export class ApimSubscriptionUpdate {
	userId: string;
	subscriptionState: SubscriptionState;
	sid: string;
	subscriptionName: string;

	constructor(userId: string, subscriptionState: SubscriptionState, sid: string, subscriptionName: string) {
		this.userId = userId;
		this.subscriptionState = subscriptionState;
		this.sid = sid;
		this.subscriptionName = subscriptionName;
	}
}

export enum ApimUserHistoryType {
	NewSubscription = 1,
	ProductionCertified = 2,
	ProductionSubscriptionUpdated = 3,
	UserStateUpdated = 4,
	UserInternalDataUpdated = 5,
	UserScreeningFeeUpdated = 6,
}

export class ApimUserHistoryRecord {
	userId: string;
	createdByUserId: string;
	userHistoryType: ApimUserHistoryType;
	details: string;
	eventDate: Date;
	additionalInfo: any;
}
